import React, { useState } from 'react';
import { Container, Typography, Box, Button, Modal, Paper } from '@mui/material';
import { Add as AddIcon } from '@mui/icons-material';
import { useQueryClient } from '@tanstack/react-query';
import Layout from '../components/Layout/Layout';
import DeviceTable from '../components/Devices/DeviceTable';
import DeviceForm from '../components/Devices/DeviceForm';
import DeviceHistoryModal from '../components/Devices/DeviceHistoryModal';

const DevicesPage = () => {
  const [openForm, setOpenForm] = useState(false);
  const [editingDevice, setEditingDevice] = useState(null);
  const [historyDeviceId, setHistoryDeviceId] = useState(null);
  const queryClient = useQueryClient();

  const handleOpenForm = () => {
    setEditingDevice(null);
    setOpenForm(true);
  };

  const handleEdit = (device) => {
    setEditingDevice(device);
    setOpenForm(true);
  };

  const handleCloseForm = () => {
    setOpenForm(false);
    setEditingDevice(null);
  };

  const handleFormSuccess = () => {
    queryClient.invalidateQueries(['devices']);
    handleCloseForm();
  };

  const handleViewHistory = (id) => {
    setHistoryDeviceId(id);
  };

  const handleCloseHistory = () => {
    setHistoryDeviceId(null);
  };

  return (
    <Layout>
      <Container maxWidth="xl" sx={{ mt: 4, mb: 4 }}>
        <Box sx={{ mb: 4, display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
          <Box>
            <Typography variant="h4" fontWeight={600}>Devices Inventory</Typography>
            <Typography variant="body1" color="textSecondary">
              Manage navigation controllers and tracking devices
            </Typography>
          </Box>
          <Button variant="contained" startIcon={<AddIcon />} onClick={handleOpenForm}>
            Add Device
          </Button>
        </Box>

        <DeviceTable 
          onEdit={handleEdit} 
          onViewHistory={handleViewHistory} 
        />

        {/* Modal для формы добавления/редактирования */}
        <Modal
          open={openForm}
          onClose={handleCloseForm}
          sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}
        >
          <Paper sx={{ width: 500, maxWidth: '90%', p: 3, borderRadius: 2 }}>
            <DeviceForm
              open={openForm}
              onClose={handleCloseForm}
              device={editingDevice}
              onSuccess={handleFormSuccess}
            />
          </Paper>
        </Modal>

        {/* Modal для истории устройства */}
        <DeviceHistoryModal
          open={!!historyDeviceId}
          deviceId={historyDeviceId}
          onClose={handleCloseHistory}
        />
      </Container>
    </Layout>
  );
};

export default DevicesPage;